import React from 'react'

const Termscon = () => {
  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px", lineHeight: "1.7" }}>
      <h1>Terms & Conditions</h1>
      <p>Last Updated: 09/12/2025</p>

      <p>
        By using Aamantran (aamantran.link), you agree to the following terms and conditions.
      </p>

      <h2>1. Services</h2>
      <p>We provide digital wedding invite creation tools, templates, and a shareable invite link.</p>

      <h2>2. User Responsibilities</h2>
      <ul>
        <li>Provide accurate information</li>
        <li>Not upload copyrighted or offensive content</li>
        <li>Not misuse or attempt to hack the platform</li>
      </ul>

      <h2>3. Account Access</h2>
      <p>Your login is for personal use only. Misuse may result in suspension.</p>

      <h2>4. Payments</h2>
      <p>
        Payments for upgrades are processed through Razorpay. 
        Prices are shown clearly before purchase.
      </p>

      <h2>5. License</h2>
      <p>You receive a personal license to use your generated wedding invite.</p>

      <h2>6. Content Ownership</h2>
      <ul>
        <li>You own your uploaded photos and details.</li>
        <li>We own all templates, layout designs, and platform code.</li>
      </ul>

      <h2>7. Limitation of Liability</h2>
      <p>
        Aamantran is not responsible for incorrect user-input details, device issues, 
        or delays in message delivery through external apps.
      </p>

      <h2>8. Termination</h2>
      <p>We may terminate accounts violating terms or engaging in suspicious activity.</p>

      <h2>9. Contact</h2>
      <p>Email: <strong>aamantran0808@gmail.com</strong></p>
    </div>
  )
}

export default Termscon